import { Language, Province } from '@vw-marketing/vw-ca-types';
import { AllOffers } from '../types/offers';

interface OffersParams {
  province: Province,
  year?: number,
  model?: string;
}
export const fetchOffers = async (
  baseUrl: string,
  lang: Language,
  params: OffersParams
) => {
  const urlQueries = Object.keys(params).map((x) => `${x}=${params[x as keyof OffersParams] as string}`);
  const urlParams = urlQueries.join("&");
  const url = `${baseUrl}/special-offers?${urlParams}`;

  const response = await fetch(url, {
    headers: {
      'Content-Language': lang,
    },
  });

if (!response.ok) return {};

  return await response.json() as AllOffers;
};
